'use strict';

import HttpHandlerService from './httpHandlerService';

const httpService4X = {};

httpService4X.install = (Vue, options = {}) => {
  Vue.prototype.$httpService = (service, component) => {
    return new HttpHandlerService(service, component, options);
  };
};

export default httpService4X;
